import {hoistCmp, uses} from '@xh/hoist/core';
import {WatchlistDialogModel} from './WatchlistDialogModel';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {Icon} from '@xh/hoist/icon';
import {dialog} from '@xh/hoist/kit/blueprint';
import {toolbar} from '@xh/hoist/desktop/cmp/toolbar';
import {filler} from '@xh/hoist/cmp/layout';
import {button} from '@xh/hoist/desktop/cmp/button';
import {grid} from '@xh/hoist/cmp/grid';
import {textInput} from '@xh/hoist/desktop/cmp/input';
import {formField} from '@xh/hoist/desktop/cmp/form';
import {form} from '@xh/hoist/cmp/form';
import {securityPicker} from '../../../../cmp/securityPicker/SecurityPicker';

export const watchlistDialog = hoistCmp.factory<WatchlistDialogModel>({
    model: uses(WatchlistDialogModel),
    render({model}) {
        return dialog({
            style: {
                width: 'fit-content',
                height: 'fit-content'
            },
            isOpen: model.isOpen,
            onClose: () => model.close(),
            title: 'Watch List',
            icon: Icon.edit(),
            item: panel({
                tbar: tbar(),
                items: [grid({width: 300, height: 400, agOptions: model.agOptions})],
                bbar: bbar(),
                mask: model.apiTask
            })
        });
    }
});

const tbar = hoistCmp.factory<WatchlistDialogModel>(({model}) =>
    toolbar(
        securityPicker({
            onSecuritySelected: security => model.addSecurity(security),
            autofocus: true,
            showSearchIcon: true,
            placeholder: 'Search tickers...',
            width: 390
        })
    )
);

const bbar = hoistCmp.factory<WatchlistDialogModel>(({model}) =>
    toolbar(
        form({
            items: [
                formField({
                    flex: 1,
                    field: 'listName',
                    label: null,
                    minimal: true,
                    item: textInput({
                        placeholder: 'list name...',
                        width: 200
                    })
                })
            ]
        }),
        filler(),
        button({
            text: 'Cancel',
            onClick: () => model.close()
        }),
        button({
            icon: Icon.check(),
            text: 'Save',
            intent: 'success',
            onClick: () => model.save()
        })
    )
);
